export const accountLabels = {
  profileTitle: {
    mobile: "Mes informations",
    desktop: "Mes informations",
  },

  updateButton: {
    mobile: "Enregistrer",
    desktop: "Mettre à jour",
  },

  paymentTitle: {
    mobile: "Mes cartes",
    desktop: "Mes moyens de paiement",
  },

  addCardButton: {
    mobile: "Ajouter",
    desktop: "Ajouter une carte",
  },
};
export const getLabel = (
  labelObj: { mobile: string; desktop: string },
  isMobile: boolean
) => (isMobile ? labelObj.mobile : labelObj.desktop);
